import { PayrollRedirectLandingPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { isManager as userIsManager } from 'modules/employees/lib/isManager'

const useEmployeePolicyData = () => {
  const { employee } = useCurrentSession()

  const employeeId = employee?.id

  const { data, loading, error } = useQuery(PayrollRedirectLandingPageDocument, {
    variables: {
      fetchEmployees: !!employeeId,
      userEmployeeId: employeeId || 0,
    },
  })

  const currentEmployeePolicyId =
    data?.employees?.employee?.payrollPolicyEmployee?.payrollPolicy?.id
  const policies = data?.payroll.policiesConnection.nodes

  const isManager = userIsManager(employee)
  const isRegularEmployee = !userIsManager(employee)

  return {
    currentEmployeePolicyId,
    policies,
    loading,
    error,
    isManager,
    data,
    isRegularEmployee,
  }
}

export default useEmployeePolicyData
